import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const propTypes = {
  t: PropTypes.func.isRequired,
};

const HowTo = ({ t }) => {
  const [bodyMovinLoaded, setBodyMovinLoaded] = useState(false);
  const [animationDataLoaded, setAnimationDataLoaded] = useState(false);
  const animationRef = useRef(null);
  const componentEltRef = useRef(null);
  const animationDataRef = useRef(null);
  const animationContainerRef = useRef(null);

  useEffect(() => {
    // Load body movin
    const bodymovinScriptTag = document.createElement("script");
    bodymovinScriptTag.type = "text/javascript";
    bodymovinScriptTag.async = true;
    bodymovinScriptTag.src =
      "https://cdnjs.cloudflare.com/ajax/libs/bodymovin/4.13.0/bodymovin.min.js";
    bodymovinScriptTag.addEventListener("load", () => {
      setBodyMovinLoaded(true);
    });
    document.head.appendChild(bodymovinScriptTag);

    // load animation through a HTTP request because it's very big
    fetch("/public/referralAnimationData.json")
      .then((res) => res.json())
      .then((animationData) => {
        animationDataRef.current = animationData;
        setAnimationDataLoaded(true);
      });

    const observer = new IntersectionObserver(([animationContainer]) => {
      if (animationContainer?.isIntersecting) {
        animationRef?.current?.play();
      } else {
        animationRef?.current?.pause();
      }
    });
    if (animationContainerRef.current) {
      observer.observe(animationContainerRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (animationRef.current || !bodyMovinLoaded || !animationDataLoaded) {
      return;
    }
    const { bodymovin } = window;
    animationRef.current = bodymovin.loadAnimation({
      container: animationContainerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: false,
      animationData: animationDataRef.current,
    });
  }, [bodyMovinLoaded, animationDataLoaded]);

  return (
    <section
      ref={componentEltRef}
      className="LandingPage-section LandingPage-howTo"
    >
      <h2 className="LandingPage-howTo-heading">
        {t("spages.referrals.landing.sections.HowTo.title")}
      </h2>
      <div className="LandingPage-howTo-inner">
        <div className="LandingPage-howTo-sectionContainer">
          <section>
            <img
              className="LandingPage-howTo-icons"
              src="/public/images/referral/create_listing.svg"
            />
            <div className="LandingPage-howTo-steps">
              <h3>
                {t("spages.referrals.landing.sections.HowTo.step1.title")}
              </h3>
              <div>
                {t("spages.referrals.landing.sections.HowTo.step1.description")}
              </div>
            </div>
          </section>
          <section>
            <img
              className="LandingPage-howTo-icons"
              src="/public/images/referral/first_booking.svg"
            />
            <div className="LandingPage-howTo-steps">
              <h3>
                {t("spages.referrals.landing.sections.HowTo.step2.title")}
              </h3>
              <div>
                {t("spages.referrals.landing.sections.HowTo.step2.description")}
              </div>
            </div>
          </section>
          <section>
            <img
              className="LandingPage-howTo-icons"
              src="/public/images/referral/key.svg"
            />
            <div className="LandingPage-howTo-steps">
              <h3>
                {t("spages.referrals.landing.sections.HowTo.step3.title")}
              </h3>
              <div>
                {t("spages.referrals.landing.sections.HowTo.step3.description")}
              </div>
            </div>
          </section>
        </div>
        <div className="LandingPage-howTo-animation-outer">
          <figure
            className="LandingPage-howTo-animation"
            ref={animationContainerRef}
          />
        </div>
      </div>
      <div className="LandingPage-howTo-callToAction">
        <h3>
          {t("spages.referrals.landing.sections.HowTo.callToAction.title")}
        </h3>
        <p className="LandingPage-howTo-callToAction-text">
          {t(
            "spages.referrals.landing.sections.HowTo.callToAction.description",
          )}
        </p>
        <button className="btn btn-action">
          {t("spages.referrals.landing.sections.HowTo.callToAction.action")}
        </button>
      </div>
    </section>
  );
};

HowTo.propTypes = propTypes;

export default HowTo;
